var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepAfter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "27CE3ABA-05ED-475D-8D79-D0B778396DB5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-437.000000, -721.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-Arrow-/-navigation-left-circle-1-1",
    transform: "translate(437.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.987,12 C23.9852147,11.311277 23.6889726,10.6561961 23.173,10.2 L11.994,0.361 C11.3937848,-0.130344205 10.5122332,-0.0579738559 10.0001871,0.524680634 C9.48814108,1.10733512 9.52961985,1.99087929 10.094,2.523 L18.731,10.123 C18.808544,10.1918032 18.8355799,10.3013257 18.798961,10.3983102 C18.7623421,10.4952947 18.6696667,10.5596174 18.566,10.56 L1.452,10.56 C0.65670996,10.56 0.012,11.20471 0.012,12 C0.012,12.79529 0.65670996,13.44 1.452,13.44 L18.563,13.44 C18.6666027,13.4409967 18.758947,13.5055478 18.7954715,13.6025039 C18.831996,13.6994599 18.8051945,13.8088948 18.728,13.878 L10.091,21.478 C9.67960973,21.8102834 9.48344901,22.3413235 9.58004156,22.8612505 C9.6766341,23.3811775 10.050437,23.8063291 10.5537216,23.9686834 C11.0570061,24.1310376 11.6087879,24.0044697 11.991,23.639 L23.172,13.8 C23.6885551,13.3441422 23.985218,12.6889356 23.987,12 Z",
    id: "icon-fill-color"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepAfter);
export default __webpack_public_path__ + "static/media/step-after.fbd56c63.svg";
export { ForwardRef as ReactComponent };